import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import * as API from '../../Endpoints/endpoint';
import './postertable.css';

function PosterDataTable() {
  const [records, setRecords] = useState([]);
    const navigate = useNavigate();

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    try {
      const res = await axios.get(API.GET_POSTER);
      setRecords(res.data);
    } catch (err) {
      console.error(err);
      alert('Failed to fetch poster data.');
    }
  };

 const handleEdit = (id) => {
    navigate(`/editposter/${id}`);
  };

  const handleView = (id) => {
    navigate(`/viewposter/${id}`);
  };

 const handleDelete = async (id) => {
  if (window.confirm(`Are you sure you want to delete SRNO: ${id}?`)) {
    try {
      await axios.delete(`${API.DELETE_POSTER}/${id}`);
      alert('Poster deleted successfully.');
      fetchRecords();
    } catch (err) {
      console.error(err);
      alert('Failed to delete poster.');
    }
  }
};

  return (
    <div className="poster-table-container">
      <h2>📑 Poster Data List</h2>
    <div style={{ marginBottom: '20px' }}>
      <Link to="/addposter">
        <button className="btn" style={{ backgroundColor: '#8B0000' }}>Add Poster</button>
      </Link>
    </div>

      <table className="poster-table">
        <thead>
          <tr>
            <th>SRNO</th>
            <th>Chart Name</th>
            <th>Language</th>
            <th>Voice</th>
            <th>Video</th>
            <th>Summary</th>
            <th>Photopdf</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.length === 0 ? (
            <tr>
              <td colSpan="8" className="no-data">No Data Found</td>
            </tr>
          ) : (
            records.map((record, index) => (
              <tr key={index}>
                <td>{record.srno}</td>
                <td>{record.chartname}</td>
                <td>{record.language}</td>
                <td>{record.voice}</td>
                <td>{record.vedio}</td>
                <td>{record.summary}</td>
                <td>{record.photopdf ? 'Available' : 'N/A'}</td>
               <td>
              <div className="action-buttons">
                <button className="btn" onClick={() => handleEdit(record.srno)}>Edit</button>
                <button className="btn" onClick={() => handleView(record.srno)}>View</button>
                <button className="btn" onClick={() => handleDelete(record.srno)}>Delete</button>
              </div>
            </td>

              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default PosterDataTable;
